// extracted by mini-css-extract-plugin
export default {"OptionContainer":"Checkbox_OptionContainer__wyS5n","Vertical":"Checkbox_Vertical__+t9uX"};